<template>
  <b-modal id="modal-request" ref="modal" size="lg" title="Request" @show="setData" @hidden="resetModal"
           @ok="handleOk">
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <div class="form-row">
        <label class="col-md-3">Date Range Leave</label>
        <div class="col-md-4 mb-3">
          <div>
            <flat-pickr v-model="input_data.date" :config="config"  @on-close="effectiveDays"></flat-pickr>
          </div>
        </div>
        <div class="col-md-2 mb-3" id="form_half_day" v-show="half_day">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" name="is_half_day" v-model="checked" @click="onCheck" id="is_half_day">
            <label class="custom-control-label" for="is_half_day">Yes, half day</label>
          </div>
        </div>
        <div class="col-md-3 mb-3">
          <div class="input-group input-group-alt">
            <input type="text" class="form-control text-right" name="nr_or_days" :value="input_data.days" id="nr_or_days" readonly placeholder="" required>
            <div class="input-group-append">
              <span class="input-group-text">Nr Or Days</span>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <label class="col-md-3">Leave Type</label>
        <div class="col-md-9 mb-3">
          <v-select :options="option_leave_type" v-model="input_data.leave_type" :reduce="leave=>leave.id" label="name" @input="checkQuotaBalance"></v-select>
        </div>
      </div>

      <div class="form-row" v-if="this.$store.getters.isMultiple">
        <label class="col-md-3" for="project">Project</label>
        <div class="col-md-9 mb-3">
          <v-select id="project" :options="option_project" v-model="input_data.project" :reduce="project=>project.id" label="name" >
          </v-select>
        </div>
      </div>

      <div class="form-row">
        <label class="col-md-3" >Balance</label>
        <div class="col-md-3 mb-3">
          <input type="text" class="form-control text-right" name="old_balance"  placeholder="Old Balance" v-model="input_data.old_balance" readonly>
        </div>
        <div class="col-md-3 mb-3">
          <input type="text" class="form-control text-right" name="new_balance"  placeholder="New Balance" v-model="input_data.new_balance" readonly>
        </div>
      </div>

      <div class="form-row">
        <label class="col-md-3" for="pic_name">PIC During Leave</label>
        <div class="col-md-9 mb-3">
          <v-select :options="option_pic" id="pic_name" v-model="input_data.pic_leave" :reduce="pic=>pic.emp_id" label="emp_name"></v-select>
        </div>
      </div>

      <div class="form-row">
        <label class="col-md-3" for="remarks">Remarks</label>
        <div class="col-md-9 mb-3">
          <input type="text" class="form-control" id="remarks" placeholder="Remarks" name="remarks" v-model="input_data.remarks" required>
        </div>
      </div>

      <div class="form-row">
        <label class="col-md-3" for="file">File</label>
        <div class="col-md-9 mb-3">
          <div class="custom-file">
            <input type="file" id="file" name="file_leave" class="custom-file-input"  ref="file" v-on:change="handleFile" />
            <label class="custom-file-label" for="file">
              Choose Files
            </label>
          </div>
          <template v-if="input_data.attachment !== null">
            <div class="list-group-item" style="cursor:pointer" v-if="imageExt.includes(getExtension(input_data.attachment))" @click="downloadFile(input_data.attachment_enc, input_data.attachment, $event)">
              <div class="list-group-item-figure">

                <div class="tile tile-img">
                  <img :src="input_data.attachment_enc" alt=""/>
                </div>
              </div>
              <div class="list-group-item-body">
                <div class="media align-items-center">
                  <div class="media-body">{{input_data.attachment}}</div>
                </div>
              </div>
            </div>
            <div class="list-group-item" style="cursor:pointer" v-else-if="this.dataEdit !== null" @click="downloadFile(input_data.attachment_enc, input_data.attachment, $event)">
              <div class="list-group-item-figure">
                <div class="tile tile-circle" >{{input_data.attachment.substring(0, 1)}}</div>
              </div>
              <div class="list-group-item-body">
                <h4 class="list-group-item-title">{{input_data.attachment}}</h4>
                <p class="list-group-item-text">{{input_data.attachment}}</p>
              </div>
            </div>
          </template>

        </div>
      </div>

      <div class="form-group" v-if="!this.$store.getters.companySettings.is_leave_auto_approve">
        <list-supervisor module="leave-request"></list-supervisor>
      </div>
    </form>
    <template v-slot:modal-footer>
      <div class="w-100">
        <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
        <button class="btn btn-warning float-right mr-1" @click="leavestat_id=1;handleOk($event)"> Submit </button>
        <button class="btn btn-primary float-right mr-1" @click="leavestat_id=0; handleOk($event)"> Save as Draft </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { BModal} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component';
import vSelect from "vue-select";
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api"
import ListSupervisor from "../employee/ListSupervisor";

export default {
  name: "LeaveRequestInput",
  components:{
    ListSupervisor,
    BModal,
    flatPickr,
    vSelect,
  },
  data(){
    return{
      config: {
        //wrap: true, // set wrap to true only when using 'input-group'
        altFormat: 'M j, Y',
        altInput: true,
        dateFormat: 'Y-m-d',
        // minDate:'today',
        mode:'range',
        locale: {
          rangeSeparator: ' - '
        },
      },
      input_data:{
        date:'',
        days:'',
        leave_type:'',
        project:'',
        pic_leave:'',
        leave_date:[],
        remarks:"",
        new_balance:0.00,
        old_balance:0.00,
        attachment_enc :"",
        attachment:""
      },
      half_day:false,
      checked:'',
      option_employee:[],
      option_project:[],
      option_pic:[],
      leavestat_id:0,
      file:null,
      imageExt:['png', 'jpg', 'jpeg']
    }
  },
  props:{
    option_leave_type: {
      type:Array
    },
    dataEdit:{
      type:Object
    }
  },
  methods:{
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      return valid
    },
    setData(){
      setTimeout(()=>{
        if (this.dataEdit !== null){
          this.input_data.date = this.dataEdit.start + " - "+this.dataEdit.end
          this.input_data.project = this.dataEdit.project_id

          this.input_data.remarks = this.dataEdit.reason
          this.input_data.pic_leave = this.dataEdit.contact_id
          this.input_data.attachment_enc = this.dataEdit.attachment_enc
          this.input_data.attachment = this.dataEdit.attachment_ori
          this.input_data.leave_type = this.dataEdit.tipe
          this.input_data.old_balance = parseFloat(this.dataEdit.old_balance).toFixed(2)
          this.input_data.new_balance = parseFloat(this.dataEdit.new_balance).toFixed(2)
          this.checked = (this.dataEdit.is_half_day == 1) ? true :false
          this.input_data.days = this.dataEdit.day_count

        }
      }, 300)
    },
    resetModal(){
      this.input_data = {
        date: '',
        days: '',
        leave_type: '',
        project: '',
        pic_leave: '',
        old_balance: 0.00,
        new_balance: 0.00,
        leave_date:[],
        attachment_enc:"",
        attachment:""
      }
      this.checked = false
      this.half_day = false
      this.$parent.dataEdit = null
      this.$refs.modal.hide()
    },
    handleOk(evt){
      evt.preventDefault()
      let [first,last] = this.input_data.date.split(" - ")

      last = (last === undefined) ? first :last
      let userProfile =  JSON.parse(this.$store.getters.userProfile).data.attributes
      let payload = {
        project_id: this.input_data.project,
        leavetype_id: this.input_data.leave_type,
        start: first,
        end: last,
        is_half_day: this.checked == 1 ? true :false,
        reason: this.input_data.remarks,
        outstanding: this.input_data.remarks,
        contact_emp_id: this.input_data.pic_leave,
        leavestat_id: this.leavestat_id,
        user_id: this.$store.getters.userId,
        new_balance : this.input_data.new_balance,
        old_balance : this.input_data.old_balance,
        unit_id: userProfile.emp_unit_id,
      }

      if (this.dataEdit !== null) payload.leave_id = this.dataEdit.id

      let formData = new FormData();

      for (let key in payload){
        formData.append(key, payload[key])
      }

      formData.append("files", this.file)


      let url = (this.dataEdit !== null) ? urlApi.leave_request.update:urlApi.leave_request.add
      if(this.dataEdit !== null){
        AxiosCall.PutFormData(formData, url).then(res=>{
          if (res.success){
            this.successMessage(res.message)
            this.$refs['modal'].hide()
            this.$parent.getData()
          }else{
            this.errorMessage(res.message)
          }
        }).catch((e)=>{
          this.errorMessage(e.response.data.message)
        })
      }else{
        AxiosCall.PostFormData(formData, url).then(res=>{
          if (res.success){
            this.successMessage(res.message)
            this.$parent.getData()
            this.$refs['modal'].hide()
          }else{
            this.errorMessage(res.message)
          }
        }).catch((e)=>{
          this.errorMessage(e.response.data.message)
        })
      }

    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    handleSubmit(){

    },
    showModal(){
      this.$refs['modal'].show()
    },
    addDays(selectedDates, dateStr, instance){
      let dateParams = []

      for (let i = 0; i < selectedDates.length; i++) {
        if(i == 1){
          dateParams.push(flatpickr.formatDate(selectedDates[i], "Y-m-d 23:59"));
        } else {
          dateParams.push(flatpickr.formatDate(selectedDates[i], "Y-m-d H:i"));
        }
      }

      this.half_day = false
      if(i == 2){
        let tDiff = this.timeDiff(dateParams[0], dateParams[1]),
            duration = Math.round(tDiff.days);

        // more than one day
        if(duration == 1){
          this.half_day = true
        }

        this.input_data.days = duration
        this.checked = (this.dataEdit !== null ? ((this.dataEdit.is_half_day == 1) ? true :false):false)
        if(this.checked)  this.input_data.days = 0.5
      }

    },
    timeDiff (date1, date2) {
      var a = new Date(date1).getTime(),
          b = new Date(date2).getTime(),
          diff = {};

      diff.milliseconds = a > b ? a % b : b % a;
      diff.seconds = diff.milliseconds / 1000;
      diff.minutes = diff.seconds / 60;
      diff.hours = diff.minutes / 60;
      diff.days = diff.hours / 24;
      diff.weeks = diff.days / 7;

      return diff;
    },
    onCheck(){
      this.input_data.days = 0.5

      if (this.checked){
        this.input_data.days = 1
      }

      let new_balance = this.input_data.old_balance - this.input_data.days

      if(new_balance > 0) this.input_data.new_balance = new_balance

    },
    getPIC(){
      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id
      }
      AxiosCall.Get(payload, urlApi.contact.list).then(res=>{
        if (res.success){
          this.option_pic = res.atributes
        }
      })
    },
    getProject(){

      let userProfile = this.$store.getters.userProfile
      let payload = {
        company_id :userProfile.data.attributes.company_id
      }
      AxiosCall.Get(payload, urlApi.project.projectAll).then(res=>{
        if (res.success){
          this.option_project  = res.atributes
        }
      })
    },
    setGroup(arr){

      const groupedTech = Object.entries(
          // What you have done
          arr.reduce((acc, { id, initial, name }) => {
            // Group initialization
            if (!acc[initial]) {
              acc[initial] = [];
            }

            // Grouping
            // FIX: only pushing the object that contains id and name

            acc[initial].push({ id, name });

            return acc;
          }, {})
      ).map(([label, options]) => ({ label, options }));

      return groupedTech
    },
    effectiveDays(selectedDates, dateStr){
      let dateParams = []

      for (let i = 0; i < selectedDates.length; i++) {
          dateParams.push(flatpickr.formatDate(selectedDates[i], "Y-m-d"));
      }
      this.half_day = false

      if(dateParams.length > 1){
        let payload = {start:dateParams[0], end:dateParams[1] }
        AxiosCall.Get(payload, urlApi.leave_request.effective_date).then(res=>{
          if(res.success){
            let duration = res.atributes.length
            this.input_data.leave_date = res.atributes
            if(duration == 1){
              this.half_day = true
            }

            this.input_data.days = duration
            this.checked = (this.dataEdit !== null ? ((this.dataEdit.is_half_day == 1) ? true :false):false)
            if(this.checked)  this.input_data.days = 0.5

            if(this.dataEdit == null){
              this.input_data.leave_type = ""
              this.input_data.new_balance = 0.00
              this.input_data.old_balance = 0.00
            }

          }else {
            this.errorMessage(res.message)
          }
        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }else {
        this.input_data.days = ""
        this.checkQuotaBalance()
      }
    },
    checkQuotaBalance(){

      if(this.input_data.leave_type !== null){
        AxiosCall.Get({leave_type_id:this.input_data.leave_type}, urlApi.leave_request.leave_quota).then(res=>{
          if(res.success){

            let leave_quota = parseFloat(res.atributes.leave_quota + res.atributes.carried_over).toFixed(2)
            if(leave_quota > 0){
              let days =  parseFloat(this.input_data.days).toFixed(2)

              if(!isNaN(days)){
                let new_balance = leave_quota - days

                if( parseFloat(days) <= parseFloat(leave_quota)){
                  this.input_data.new_balance = isNaN(new_balance) ? 0 : parseFloat(new_balance).toFixed(2)
                  this.input_data.old_balance = leave_quota
                }else{
                  this.errorMessage("Quota insufficient balance.")
                  this.input_data.new_balance = 0.00
                }
              }else{
                this.input_data.old_balance = leave_quota
                this.input_data.new_balance = leave_quota
              }


            }else{
              this.errorMessage("Quota was empty")
              this.input_data.new_balance = 0
              this.input_data.old_balance = 0
            }

          }else{
            this.errorMessage(res.message)
          }

        }).catch(e=>{
          this.errorMessage(e.response.data.message)
        })
      }else{
        this.input_data.new_balance = 0
        this.input_data.old_balance = 0
      }

    },
    handleFile(){
        this.file = this.$refs.file.files[0];
    },
    getExtension(filename){
      let re = /(?:\.([^.]+))?$/;

      let ext = re.exec(filename)[1];
      return ext
    },
    downloadFile(url, name, evt){
      evt.preventDefault()
      window.open(url, '_blank');
    }
  },
  mounted() {
    this.getProject()
    this.getPIC()
  },
}
</script>